export interface IScansEnabledProps {
  teamName: string;
  effectiveTeamName: string;
}

export interface CoreObject {
  // The enabled_features flag marking that the team has this core object.
  flag: string;
  // Display name and child-flag prefix (e.g., "AUDIT").
  prefix: string;
  label: string;
}

export interface ChildObject {
  // Suffix used in the scoped flag name, e.g., "TASKGROUP".
  key: string;
  label: string;
  description: string;
}

// Core objects are shown as a group when the team has them (via its AUDIT/NOTICE flags).
export const CORE_OBJECTS: CoreObject[] = [
  { flag: "AUDIT", prefix: "AUDIT", label: "Audit" },
  { flag: "NOTICE", prefix: "NOTICE", label: "Notice" },
];

// Child objects toggled per core object; the scoped flag is FILE_SCAN_<CORE>_<CHILD>.
export const CHILD_OBJECTS: ChildObject[] = [
  {
    key: "TASKGROUP",
    label: "Task groups and tasks",
    description:
      "Extract task groups, tasks, owners, and due dates from requests in the document.",
  },
  {
    key: "ASSESSMENT",
    label: "Assessments",
    description:
      "Extract assessed tax, interest, and penalty amounts by tax period.",
  },
  {
    key: "PAYMENT",
    label: "Payments",
    description: "Extract payment amounts, due dates, and payment methods.",
  },
];

export const childScanFlag = (corePrefix: string, childKey: string): string =>
  `FILE_SCAN_${corePrefix}_${childKey}`;
